import { Component, DestroyRef, ElementRef, OnInit, inject, viewChild } from '@angular/core';
import { ReservationSummaryDocumentsComponent } from '../reservation-summary/reservation-summary-documents/reservation-summary-documents.component';
import { Reservation } from '../reservation.model';
import { DatePipe } from '@angular/common';
import { filter } from 'rxjs';
import { PricePipe } from '@/common/pipes/price.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import {
	ReservationDocumentKind,
	ReservationDocumentKindDialogComponent,
	ReservationDocumentKindDialogResult,
} from './reservation-document-kind-dialog/reservation-document-kind-dialog.component';

@Component({
	selector: 'app-reservation-documents',
	templateUrl: './reservation-documents.component.html',
	styleUrls: ['./reservation-documents.component.scss'],
	providers: [DatePipe, PricePipe],
})
export class ReservationDocumentsComponent extends ReservationSummaryDocumentsComponent implements OnInit {
	readonly displayedColumns: string[] = ['icon', 'name', 'date', 'author'];

	private readonly fileInput = viewChild<ElementRef<HTMLInputElement>>('Input');

	private readonly destroyRef = inject(DestroyRef);
	private readonly dialog = inject(MatDialog);

	private pendingDocumentKind: ReservationDocumentKind = '';

	ngOnInit(): void {
		this._service.reservation$
			.pipe(
				filter((value) => !!value),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((value: Reservation) => {
				this.reservation = value;
			});

		this.store
			.getters()
			.document()
			.pipe(
				filter((v) => !!v),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((v) => {
				this.documents = v.filter((value) => value.name !== 'reservation_cash_confirmation');
			});
	}

	openUploadDialog(): void {
		this.dialog
			.open<ReservationDocumentKindDialogComponent, void, ReservationDocumentKindDialogResult>(
				ReservationDocumentKindDialogComponent,
				{ width: '400px' },
			)
			.afterClosed()
			.pipe(filter((result): result is ReservationDocumentKindDialogResult => !!result))
			.subscribe((result) => {
				this.pendingDocumentKind = result.kind;
				this.fileInput()?.nativeElement.click();
			});
	}

	onDocumentsSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.attachDocuments(event, this.pendingDocumentKind);
		this.pendingDocumentKind = '';
		input.value = '';
	}
}
